import React from "react";
import "./ctaSection.css";

const CTASection = () => (
  <section className="cta">
    <h2 className="cta__title">¡Sé parte de la revolución Gastronómica!</h2>
  </section>
);
export default CTASection;
